import CreateNewTemplateCategory from '@/connection/categories/create-new-template-category';
import { TemplatesReducerCreator } from '../types';

const createNewTemplateCategoryReducer = (create: TemplatesReducerCreator) => {
  return create.asyncThunk(
    async ({ channel, title }: { channel: number; title: string }) => {
      return CreateNewTemplateCategory({ channel, title });
    },
    {
      fulfilled: (state, action) => {
        if (!state.categoryFilters) {
          state.categoryFilters = [];
        }
        state.categoryFilters.push({
          ...action.payload,
          events: [],
        });
      },
      rejected: (state, action) => {
        console.error(action.error);
      },
    }
  );
};

export default createNewTemplateCategoryReducer;
